module.exports = __webpack_public_path__ + "static/media/li.f665b479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/li.png
// module id = 1907
// module chunks = 0